import styles from "./styles.module.css";
import { useState } from "react";
import Modal from "../../../modal";
import { MdAdd, MdClose } from "react-icons/md";
import { db } from "../../../firebase";
import { useParams } from "react-router-dom";
import { makeid } from "../../../utils/pageactions";

export default function Add() {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const { appId } = useParams();

  const handleSave = () => {
    db.collection("apps")
      .doc(appId)
      .collection("apis")
      .doc(makeid(24))
      .set({ name, headers: [], calls: [] })
      .then(() => {
        setName("");
        setOpen(false);
      });
  };
  return (
    <div onClick={() => setOpen(true)} className={styles.add}>
      <div>ADD API</div>
      <Modal onClose={() => setOpen(false)} open={open}>
        <div className={styles.form}>
          <div className={styles.formTitle}>
            Add API{" "}
            <MdClose onClick={() => setOpen(false)} className={styles.close} />
          </div>
          <div className={styles.formContainer}>
            <div className={styles.formInputTitle}>API Name</div>
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="name..."
              className="input"
            />
          </div>
          <div className={styles.formContainer}>
            <button disabled={name.length === 0} onClick={handleSave}>
              Submit
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
